import { StoreState } from '../../../store';

export const reportJobSelector = (state: StoreState) => state.viewReports.reportJob;

export const reportDataSelector = (state: StoreState) => state.viewReports.reportData;

export const reportColumnsSelector = (state: StoreState) => state.viewReports.columns;

export const reportColumnOptionsSelector = (state: StoreState) => state.viewReports.columnOptions;

export const containerLinksMapSelector = (state: StoreState) => state.viewReports.containerLinksMap;

export const isReportDataStaleSelector = (state: StoreState) => state.viewReports.isReportDataStale;
